import * as _ from 'lodash';
import { Group } from '../../models/entities';

export const getIdentifiersForGroupsOnMap = (groups: Group[]) => {
    return _.flatten(groups.map((group) => group.identifierCollection));
};
